import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ButtonMargin} from "@/lib/components/UI/enum/ButtonMargin";
import PageFooter from "@/lib/components/layout/page/PageFooter.vue";
import ButtonGroup from "@/lib/components/UI/ButtonGroup.vue";
import {ButtonData} from "@/lib/components/UI/type/ButtonData";
import {PropType, ref, watch} from "vue";
import AnnotatableImagesDownloadHelper from "@/helpers/AnnotatableImagesDownloadHelper";
import {SSegmentedImage} from "@/store/Spatial2DAnnotation/model/SSegmentedImage";
import Segmentation2DPage from "@/views/Segmentation2D/Segmentation2DPage.vue";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'Segmentation2DFooter',
  props: {
  images: Array as PropType<SSegmentedImage[]>,
  segmentation2DPageRef: Object as PropType<typeof Segmentation2DPage>
},
  setup(__props) {

const props = __props




let isImagesEmpty = ref(true);

watch(() => props.images, () => {
  isImagesEmpty.value = !props.images || !props.images.length;
})

// ------------------------------
//  Download buttons
// ------------------------------

const bottomDownloadButtons: ButtonData[] = [
  {
    id: "download json data",
    text: "Download JSON data",
    icon: require("@/lib/assets/img/icons/json.svg"),
    isDisabled: isImagesEmpty
  },
];

const onBottomDownload = (buttonId: string) =>
{
  switch (buttonId) {

    case "download json data":
      onDownloadJsonData();
      break;
  }
}

const onDownloadJsonData = () =>
{
  if (props.segmentation2DPageRef)
    AnnotatableImagesDownloadHelper.downloadAllAnnotatedImagesData(props.segmentation2DPageRef.overlayableImagesCarouselRef.carouselImages)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageFooter, null, {
    "footer-content-center": _withCtx(() => [
      _createVNode(ButtonGroup, {
        buttons: bottomDownloadButtons,
        margin: _unref(ButtonMargin).EXTRA_WIDE,
        onClick: onBottomDownload
      }, null, 8, ["margin"])
    ]),
    _: 1
  }))
}
}

})